import { ref, nextTick } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7b577207"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "echarts-content"
};
const _hoisted_2 = {
  class: "filter-new-content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "reason-content"
}, null, -1));
const _hoisted_4 = {
  class: "filter-content"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "结算货币：", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "canvas"
}, null, -1));
import * as echarts from 'echarts/core';
import { LineChart } from 'echarts/charts';
import { TitleComponent, TooltipComponent, GridComponent,
// 数据集组件
DatasetComponent,
// 内置数据转换器组件 (filter, sort)
TransformComponent, LegendComponent, DataZoomComponent } from 'echarts/components';
import { LabelLayout, UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';
import Empty from '@/components/Empty.vue';
import { awaitWrap, OK } from '@/common';
import { queryTrendChart } from '@/api/paidApi';
// 注册必须的组件
export default /*#__PURE__*/_defineComponent({
  __name: 'EchartsContent',
  setup(__props, {
    expose
  }) {
    echarts.use([TitleComponent, TooltipComponent, GridComponent, DatasetComponent, TransformComponent, LineChart, LabelLayout, UniversalTransition, CanvasRenderer, LegendComponent, DataZoomComponent]);
    const enToZh = {
      cnyAmount: '销售额（CNY）',
      cnyRevenue: '总收入(CNY)',
      dt: '购买时间',
      orderAmount: '下载量',
      refundOrderAmount: '退款订单数量',
      usdAmount: '销售额（USD）',
      usdRevenue: '总收入（USD）'
    };
    const xData = ref([]);
    const selectedList = ref([]);
    const seriesData = ref([]);
    const currency = ref(2);
    const searchForm = ref({});
    const loading = ref(true);
    const createChart = () => {
      if (!document.getElementById('canvas')) {
        return false;
      }
      echarts.dispose(document.getElementById('canvas'));
      const chartDom = document.getElementById('canvas'),
        myChart = echarts.init(chartDom);
      let options = {
        tooltip: {
          trigger: 'axis',
          enterable: true
        },
        color: ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc', '#fd7f82', '#ffa748'],
        legend: {
          data: selectedList.value,
          top: '93%'
        },
        grid: {
          left: '.5%',
          right: '2.5%',
          bottom: '10%',
          top: 24,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xData.value
        },
        yAxis: {
          type: 'value'
        },
        series: seriesData.value
      };
      myChart.resize();
      myChart.clear();
      myChart.setOption(options);
      loading.value = false;
    };
    const getData = async (searchObj = {}) => {
      var _Object$keys;
      if ((_Object$keys = Object.keys(searchObj)) !== null && _Object$keys !== void 0 && _Object$keys.length) {
        searchForm.value = searchObj;
      }
      let params = {};
      Object.keys(searchForm.value).forEach(item => {
        var _searchForm$value$ite;
        if (searchForm.value[item] || searchForm.value[item] && (_searchForm$value$ite = searchForm.value[item]) !== null && _searchForm$value$ite !== void 0 && _searchForm$value$ite.length) {
          params = {
            ...params,
            [item]: searchForm.value[item]
          };
        }
      });
      loading.value = true;
      const [err, data] = await awaitWrap(queryTrendChart(params));
      if (data && data.code === OK) {
        var _data$data;
        handleData((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.list);
      }
      if (err) {}
      loading.value = false;
    };
    const handleData = data => {
      // 数据清空
      seriesData.value = [];
      xData.value = [];
      selectedList.value = [];
      if (data !== null && data !== void 0 && data.length) {
        // 处理折线数据
        selectedList.value = Object.keys(data[0]);
        selectedList.value.splice(selectedList.value.indexOf('dt'), 1);
        selectedList.value = selectedList.value.filter(i => !i.includes(currency.value === 1 ? 'cny' : 'usd'));
        let arr = selectedList.value.map(item => {
          return {
            name: item,
            type: 'line',
            data: []
          };
        });
        data.forEach(item => {
          xData.value = [...xData.value, item.dt];
          arr.forEach(j => {
            j.data = [...j.data, item[j.name]];
          });
        });
        // 处理中英文展示名称
        selectedList.value = selectedList.value.map(item => enToZh[item] || item);
        arr = arr.map(item => {
          return {
            ...item,
            name: enToZh[item.name] || item.name
          };
        });
        seriesData.value = arr;
        // 绘图
        nextTick(() => {
          createChart();
        });
      }
    };
    const changeRadio = () => {
      getData();
    };
    // onMounted(() => {
    //   nextTick(() => {
    //     window.addEventListener('resize', createChart)
    //   })
    // })
    // onUnmounted(() => {
    //   window.removeEventListener('resize', createChart)
    // })
    expose({
      getData
    });
    return (_ctx, _cache) => {
      var _xData$value;
      const _component_a_radio = _resolveComponent("a-radio");
      const _component_a_radio_group = _resolveComponent("a-radio-group");
      const _component_a_spin = _resolveComponent("a-spin");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_a_radio_group, {
        value: currency.value,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => currency.value = $event),
        name: "radioGroup",
        onChange: changeRadio
      }, {
        default: _withCtx(() => [_createVNode(_component_a_radio, {
          value: 1
        }, {
          default: _withCtx(() => [_createTextVNode("美元")]),
          _: 1
        }), _createVNode(_component_a_radio, {
          value: 2
        }, {
          default: _withCtx(() => [_createTextVNode("人民币")]),
          _: 1
        })]),
        _: 1
      }, 8, ["value"])])]), (_xData$value = xData.value) !== null && _xData$value !== void 0 && _xData$value.length ? (_openBlock(), _createBlock(_component_a_spin, {
        key: 0,
        spinning: loading.value
      }, {
        default: _withCtx(() => [_hoisted_6]),
        _: 1
      }, 8, ["spinning"])) : (_openBlock(), _createBlock(Empty, {
        key: 1
      }))]);
    };
  }
});